export const REF_NAME = 'EXPENSECATEGORY';
export const REF_PATH = 'expensecategory';
export const NAME = 'Expense category';
